module.exports = __webpack_public_path__ + "img/eclipse-rectangle-top-angle.0b6dbef9.png";